export const title = 'Downloads';

Number of new app installations.
